
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDOhlehQQqByL_83u4J7ocV12sC1Ubg-4w",
  authDomain: "pet-plazza-109b4.firebaseapp.com",
  projectId: "pet-plazza-109b4",
  storageBucket: "pet-plazza-109b4.firebasestorage.app",
  messagingSenderId: "961013605272",
  appId: "1:961013605272:web:e822ec0e70925788d881ed",
  measurementId: "G-MWXDTZRGWL"
 
};


const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;